import * as React from 'react'

const useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect

function useEventCallback<Fn extends (...args: any[]) => any = (...args: unknown[]) => unknown>(fn: Fn): Fn
function useEventCallback<Args extends unknown[], Return>(fn: (...args: Args) => Return): (...args: Args) => Return
function useEventCallback<Args extends unknown[], Return>(fn: (...args: Args) => Return): (...args: Args) => Return {
    const ref = React.useRef(fn)
    useEnhancedEffect(() => {
        ref.current = fn
    })
    return React.useRef((...args: Args) => ref.current(...args)).current
}

export default useEventCallback
